import type { AdminAiScanKind } from "../models/admin-ai-scans.models";

export const ADMIN_AI_SCAN_TYPES: ReadonlyArray<{ id: AdminAiScanKind; label: string }> = [
  { id: "features", label: "Features" },
  { id: "ac", label: "AC" },
  { id: "security", label: "Security" },
  { id: "nulls", label: "Nulls" },
  { id: "validations", label: "Validations" },
  { id: "resilience", label: "Resilience" },
];

export const ADMIN_AI_SCAN_SEVERITIES = ["red", "orange", "yellow", "lime", "green"] as const;
export const ADMIN_AI_SCAN_SEVERITY_ALIASES: ReadonlyMap<string, string> = new Map([
  ["critical", "red"],
  ["high", "orange"],
  ["medium", "yellow"],
  ["low", "lime"],
  ["info", "green"],
  ["verified", "green"],
]);
export const ADMIN_AI_SCAN_SEVERITY_LABELS: Record<string, string> = {
  red: "Critical",
  orange: "High",
  yellow: "Medium",
  lime: "Low",
  green: "Info / verified",
  unknown: "Unspecified",
};
export const ADMIN_AI_SCAN_TONE_CLASSES: Record<string, string> = {
  red: "bg-red-600 text-white",
  orange: "bg-orange-400 text-slate-950",
  yellow: "bg-yellow-400 text-slate-950",
  lime: "bg-lime-400 text-slate-950",
  green: "bg-green text-white",
  unknown: "bg-slate-200 text-slate-800 dark:bg-gray-600 dark:text-white",
};

export const ADMIN_AI_SCAN_FINDING_FIELD_LABELS: Record<string, string> = {
  unsafeScenario: "What can go wrong",
  explanation: "Why this matters",
  remediation: "Recommended fix",
  detail: "Details",
};

// Keep identifiers and raw source locations available without interrupting the finding's explanation.
export const ADMIN_AI_SCAN_FINDING_TECHNICAL_FIELDS = new Set([
  "canonicalKey",
  "affectedFeatureIds",
  "affectedEndpointIds",
  "remediationIds",
  "filePath",
  "line",
  "symbol",
]);
